(function($, App, Utils, Components){
  'use strict';

  Components.create('CouponLoyalGuru', {

    bindEvents: function() {
      const couponCard = $(".coupon-card");

    $('.coupon-btn-wrapper').on('click', function (event) {
      const isDisabledDeselect = $(event.currentTarget).hasClass('disabled-deselect');
      const isSelectBtnSelected = $(event.currentTarget).find('.select-btn').hasClass('selected');

      if (isDisabledDeselect != true || (isDisabledDeselect == true && isSelectBtnSelected != true)) {
        event.stopPropagation();
      }
    });


      couponCard.on('click', function(e) {
        const couponName = e.currentTarget.getAttribute('data-nome');
        const couponDescription = e.currentTarget.getAttribute('data-descrizione');
        const couponImage = e.currentTarget.getAttribute('data-img');
        const couponUsedRedemptions = e.currentTarget.getAttribute('data-used-redemptions');
        const couponMaxRedemptions = e.currentTarget.getAttribute('data-max-redemptions');
        const couponExpirationDateFrom = e.currentTarget.getAttribute('data-datainizio');
        const couponExpirationDateTo = e.currentTarget.getAttribute('data-datafine');
        const couponSelected = e.currentTarget.getAttribute('data-selected');
        const couponExpiring = e.currentTarget.getAttribute('data-expiring');
        const couponRemoveDeselectOption = e.currentTarget.getAttribute('data-remove-deselect-option');
        const couponBtnLabel = e.currentTarget.getAttribute('data-btn-label');
        const couponBtnUrl = e.currentTarget.getAttribute('data-btn-url');
        const couponDeleteBtnUrl = e.currentTarget.getAttribute('data-delete-btn-url');
        const couponIconClass = e.currentTarget.getAttribute('data-icon-class');
        const couponCode = e.currentTarget.getAttribute('data-code');
        const couponUsableTag = e.currentTarget.getAttribute('data-usable-tag');        
        const couponUsable = e.currentTarget.getAttribute('data-usable-label');
        const couponOnlineOnly = e.currentTarget.getAttribute('data-online-only');
        const couponPrintedOnReceipt = e.currentTarget.getAttribute('data-on-receipt-coupon');


        $(".coupon-detail-name").html(couponName);
        $(".coupon-detail-description").html(couponDescription);
        $(".coupon-detail-img").attr("src", couponImage);
        $(".coupon-detail-expiration .expiration-date-from").html(couponExpirationDateFrom);
        $(".coupon-detail-expiration .expiration-date-to").html(couponExpirationDateTo);
        $(".coupon-detail-expiration-until .expiration-date-to").html(couponExpirationDateTo);
        $(".coupon-detail-redemptions .redemption-count").html(couponUsedRedemptions);
        $(".coupon-detail-max-redemptions .max-redemption-count").html(couponMaxRedemptions);
        $(".coupon-detail-btn-wrapper .select-btn").empty().prepend(couponBtnLabel, $('<i>'));
        $(".coupon-detail-btn-wrapper .select-btn i").addClass("icon " + couponIconClass);
        $(".coupon-detail-btn-wrapper .select-btn").attr("href", couponBtnUrl);
        $(".coupon-detail-btn-wrapper .delete-btn").attr("href", couponDeleteBtnUrl);
        $(".coupon-detail-online-tag").html(couponUsableTag);
        $(".coupon-detail-online-tag-description").html(couponUsable);

        // Show/hide expiring tag
        couponExpiring !== "true" ? $(".coupon-detail-expiring-tag").addClass("hide") : $(".coupon-detail-expiring-tag").removeClass("hide");
        // Show/hide barcode
        couponSelected !== "true" || couponOnlineOnly === "true" || couponPrintedOnReceipt === "true" ? $(".coupon-detail-barcode").addClass("hide") : $(".coupon-detail-barcode").removeClass("hide");
        // Show/hide redemptions count
        couponMaxRedemptions <= "1" ? $(".coupon-detail-redemptions-wrapper").addClass("hide") : $(".coupon-detail-redemptions-wrapper").removeClass("hide");
        // Show/hide desired label
        couponPrintedOnReceipt == "true" ? $(".coupon-detail-expiration").addClass("hide") : $(".coupon-detail-expiration").removeClass("hide")
        couponPrintedOnReceipt == "true" ? $(".coupon-detail-expiration-until").removeClass("hide") : $(".coupon-detail-expiration-until").addClass("hide");
        couponPrintedOnReceipt == "true" ? $(".coupon-detail-bottom-label").removeClass("hide") : $(".coupon-detail-bottom-label").addClass("hide");
        couponPrintedOnReceipt == "true" ? $(".coupon-detail-btn-wrapper").addClass("hide") : $(".coupon-detail-btn-wrapper").removeClass("hide");

        // Show/hide selected and delete btn
        if (couponSelected === "true" && couponRemoveDeselectOption !== "true") {
          $(".coupon-detail-btn-wrapper .select-btn").addClass("selected");
          $(".coupon-detail-btn-wrapper .delete-btn").removeClass("hide");
        } else if (couponSelected === "true" && couponRemoveDeselectOption === "true") {
          $(".coupon-detail-btn-wrapper .delete-btn").addClass("hide");
          $(".coupon-detail-btn-wrapper .select-btn").addClass("selected")
        } else {
          $(".coupon-detail-btn-wrapper .delete-btn").addClass("hide");
          $(".coupon-detail-btn-wrapper .select-btn").removeClass("selected")
        }

        // Coupon terms and condition
        const couponDiscount = e.currentTarget.getAttribute('data-discount');
        const couponHasPoints = e.currentTarget.getAttribute('data-has-points');
        const couponPointsMoney = e.currentTarget.getAttribute('data-points-money');
        const couponDataUnits = e.currentTarget.getAttribute('data-units');
        const couponDataValue = e.currentTarget.getAttribute('data-value');
        const couponCumulative = e.currentTarget.getAttribute('data-cumulative');

        $(".coupon-detail-info .discount").html(couponDiscount);
        $(".coupon-detail-info .hasPoints").html(couponHasPoints);
        $(".coupon-detail-info .pointsMoney").html(couponPointsMoney);
        $(".coupon-detail-info .units").html(couponDataUnits);
        $(".coupon-detail-info .value").html(couponDataValue);
        $(".coupon-detail-info .cumulative").html(couponCumulative);

        // Set coupon barcode value and reinitialize JsBarcode
        $(".coupon-detail-barcode .coupon-barcode").empty().attr("jsbarcode-value", couponCode);
        JsBarcode(".coupon-detail-barcode .coupon-barcode").init();

      })

      // Coupon filter
      $('#coupon-filter').on('change', function () {
        const selectedValue = this.value;
        const filteredCouponsUrl = `/my-account/coupon-entry-point/coupon?status=${selectedValue}`;
        window.location.href = filteredCouponsUrl;
      });

      // Coupon entry point
      // Open modal if the user card is not associated
      const couponEntryPointLink = $(".myaccount-coupon-entrypoint .coupon-gallery-link");
      couponEntryPointLink.attr("data-open-modal") === "true" ? couponEntryPointLink.attr("data-modal", true) : '';

      // Coupon gallery
      const couponGalleryBanner = $(".coupon-gallery-banner .personalized-coupon-banner");
      couponGalleryBanner.attr("data-open-modal") === "true" ? couponGalleryBanner.attr("data-modal", true) : '';

      // Fidelity card coupon gallery CTA link disabled
      $(".fidelity-card .coupon-gallery-cta").on("click", function(event) {
        $(this).hasClass("greyed-out") ? event.preventDefault() : '';
      })

    },

    init: function() {
      this.bindEvents();
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);
